import type { JSX } from '@builder.io/qwik';
import { component$ } from '@builder.io/qwik';
import type { InstagramBlockAttsInterface } from '~/types/AppData/Blocks/InstagramBlockInterface';
import Embed from '~/components/Shared/Embeds/Embed';

export default component$((value: InstagramBlockAttsInterface): JSX.Element => {
  return (
    <Embed
      embed={value.html}
      type='instagram'
      isLoadedProp='mmInstagramLoaded'
      loadScript='https://www.instagram.com/embed.js'
    />
  );
});
